var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M648 983q-91 0-169-46-76-44-121-120-46-79-46-170t46-169q45-76 121-120 78-46 169-46t169 46q76 44 121 120 46 78 46 169t-46 170q-45 76-121 120-78 46-169 46zM515 847q60 41 133 41 65 0 120.5-32.5T856 768t32-121q1-72-40-132zm133-440q-65 0-120.5 32.5T440 527t-32 120q-1 73 40 133l333-333q-60-40-133-40zM47 43h553q10 0 16.5 7t6.5 16v29q0 9-6.5 16t-16.5 7H47q-10 0-17-7t-7-16V66q0-9 7-16t17-7zm0 139h553q10 0 16.5 7t6.5 17v28q0 10-6.5 16.5T600 257H47q-10 0-17-6.5T23 234v-28q0-10 7-17t17-7zm0 140h246q10 0 16.5 6.5T316 345v28q0 10-6.5 17t-16.5 7H47q-10 0-17-7t-7-17v-28q0-10 7-16.5t17-6.5zm0 139h153q10 0 16.5 7t6.5 16v29q0 9-6.5 16t-16.5 7H47q-10 0-17-7t-7-16v-29q0-9 7-16t17-7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockList);
export default __webpack_public_path__ + "static/media/block-list.fae02c1f056881f16bc161cc1e12be4e.svg";
export { ForwardRef as ReactComponent };